export default function CenterContainer({children}) {
    return (
        <div className={"d-flex align-items-center justify-content-center"}>
            {children}
        </div>
    );
};